import { getConfig } from './config'
import IdfTrackingService from './services/idf-tracking.service'

const idfTrackingApiHost = getConfig().idfTrackingApiHost

export const idfTrackingService = new IdfTrackingService(idfTrackingApiHost)
